/**
 * Offer Service
 * Business logic for offer management
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * Offer Service
 * Handles offer fetching, caching, and business logic
 */
export class OfferService {
    constructor(offerAPI) {
        this.offerAPI = offerAPI;
        this.offerCache = new Map();
    }
    /**
     * Get offer details (with caching)
     */
    getOfferDetail(offerCode_1, sessionId_1) {
        return __awaiter(this, arguments, void 0, function* (offerCode, sessionId, useCache = true) {
            // Check cache first
            if (useCache && this.offerCache.has(offerCode)) {
                return this.offerCache.get(offerCode);
            }
            // Fetch from API
            const detail = yield this.offerAPI.fetchOfferDetails(offerCode, sessionId);
            // Cache the result
            this.offerCache.set(offerCode, detail);
            return detail;
        });
    }
    /**
     * Get offers by brand ID
     */
    getOffersByBrandId(brandId, token) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.offerAPI.fetchOffersByBrandId(brandId, token);
        });
    }
    /**
     * Get offers by category ID
     */
    getOffersByCategoryId(categoryId, token) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log("[OfferService] Fetching offers for category:", categoryId);
            const offers = yield this.offerAPI.fetchOffersByCategoryId(categoryId, token);
            console.log("[OfferService] Received offers:", offers.length);
            return offers;
        });
    }
    /**
     * Clear offer cache
     */
    clearCache() {
        this.offerCache.clear();
    }
    /**
     * Calculate final price after discount
     */
    calculateFinalPrice(originalPrice, discountPercentage) {
        const price = typeof originalPrice === "string"
            ? parseFloat(originalPrice)
            : originalPrice;
        const discount = typeof discountPercentage === "string"
            ? parseFloat(discountPercentage)
            : discountPercentage;
        return price * (1 - discount / 100);
    }
}
